import { Outlet } from "react-router";
import { VideoFocusProvider } from "../contexts/VideoFocusProvider";

export function RootLayout() {
  return (
    <VideoFocusProvider>
      <Outlet />
    </VideoFocusProvider>
  );
}
